import { t } from "i18next";

const CustomAudioRenderer = ({ mainState: { currentDocument } }) => {
  if (!currentDocument) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <audio controls>
        <source src={currentDocument.uri} type="audio/mpeg" />
        <source src={currentDocument.uri} type="audio/wav" />
        <source src={currentDocument.uri} type="audio/ogg" />
        {t("documentViewer.audioError")}
      </audio>
    </div>
  );
};

CustomAudioRenderer.fileTypes = ["mp3", "wav", "ogg", "m4a"];
CustomAudioRenderer.weight = 1;

export default CustomAudioRenderer;
